var components
try {
  components = {
    almostLottery: function () {
      return import(
        /* webpackChunkName: "uni_modules/almost-lottery/components/almost-lottery/almost-lottery" */ "@/uni_modules/almost-lottery/components/almost-lottery/almost-lottery.vue"
      )
    },
  }
} catch (e) {
  if (
    e.message.indexOf("Cannot find module") !== -1 &&
    e.message.indexOf(".vue") !== -1
  ) {
    console.error(e.message)
    console.error("1. 排查组件名称拼写是否正确")
    console.error(
      "2. 排查组件是否符合 easycom 规范，文档：https://uniapp.dcloud.net.cn/collocation/pages?id=easycom"
    )
    console.error(
      "3. 若组件不符合 easycom 规范，需手动引入，并在 components 中注册该组件"
    )
  } else {
    throw e
  }
}
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var m0 = _vm.points_name()
  var m1 = _vm.points_name()
  var m2 = _vm.points_name()
  var g0 = _vm.prizeList.length
  var l0 = _vm.__map(_vm.listData, function (item, index) {
    var $orig = _vm.__get_orig(item)
    var m3 = _vm.points_name(item.showText)
    return {
      $orig: $orig,
      m3: m3,
    }
  })
  var m4 = _vm.points_name(_vm.result.name)
  var l1 = _vm.__map(_vm.recordList, function (item, index) {
    var $orig = _vm.__get_orig(item)
    var m5 = _vm.points_name(item.record_name)
    return {
      $orig: $orig,
      m5: m5,
    }
  })
  var g1 = _vm.recordList.length == 0 && !_vm.loading
  if (!_vm._isMounted) {
    _vm.e0 = function ($event) {
      _vm.isRule = true
    }
    _vm.e1 = function ($event) {
      _vm.prizeIndex = -1
    }
    _vm.e2 = function ($event) {
      _vm.isRule = false
    }
  }
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        m0: m0,
        m1: m1,
        m2: m2,
        g0: g0,
        l0: l0,
        m4: m4,
        l1: l1,
        g1: g1,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }